import { select, put, call, all } from 'redux-saga/effects'
import messageTypes from '../../../enums/messageTypes'
import that from '../../../utilities/translationHelper'
import actionCreators from '../../actionCreators' // eslint-disable-line import/no-named-as-default
import { prepareForSave } from '../firebase/document'
import { selectUserProfile } from '../../selectors'

export function* triggerUserProfileKitAdd(args) {
	yield put(actionCreators.userProfileKitAdd(args))
}

export function* onDuplicateSuccess({ kit }) {
	yield put(actionCreators.appMessageInternal(messageTypes.POSITIVE, that.context.translate('Kit "{name}" created.', { name: kit.name })))
}

export function* getParamsForKitSuggestionSet(params) {
	const kitSuggestion = Array.isArray(params.kitSuggestion) ? yield all(params.kitSuggestion.map(ks => call(prepareForSave, ks))) : yield call(prepareForSave, params.kitSuggestion)
	return {
		...params,
		kitSuggestion
	}
}

export function* getParamsForKitDraftSet(params) {
	let { kitDraft } = params
	if (!kitDraft) {
		kitDraft = yield select(state => state.kitDraft)
	}
	kitDraft = yield call(prepareForSave, kitDraft)
	const userProfile = yield select(selectUserProfile)
	kitDraft.userName = userProfile.userName
	kitDraft.profileImages = userProfile.images
	return {
		...params,
		kitDraft
	}
}

export function* selectKitOwnById(params) {
	const stateKitOwnById = yield select(state => state.kitOwnById)
	return {
		...params,
		stateKitOwnById
	}
}



// WEBPACK FOOTER //
// ./src/redux/saga/kits/sagas.js